
import { defineComponent, type PropType } from "vue-demi";
import GGTimerBlock from "./GGTimerBlock.vue";
import GGPromoButton from "./GGPromoButton/GGPromoButton.vue";

export default defineComponent({
  name: "GGGroupTitle",
  components: {
    GGTimerBlock,
    GGPromoButton,
  },
  props: {
    title: {
      type: String as PropType<string>,
      default: undefined,
    },
    /**
     * Формат времени '2020-11-26T00:00:00'
     */
    timerDate: {
      type: String as PropType<string | null>,
      default: null,
    },
    timerColor: {
      type: String as PropType<string>,
      default: "black",
      validator(el) {
        return ["red", "black"].some((item) => item === el);
      },
    },
    timerSize: {
      type: String as PropType<string>,
      default: "s",
      validator(el) {
        return ["s", "m", "l"].some((item) => item === el);
      },
    },
    iconLeft: {
      type: String as PropType<string>,
      default: undefined,
    },
    iconRight: {
      type: String as PropType<string>,
      default: undefined,
    },
    imgDesktop: {
      type: String as PropType<string>,
      default: undefined,
    },
    imgMobile: {
      type: String as PropType<string>,
      default: undefined,
    },
    imgLink: {
      type: String as PropType<string>,
      default: undefined,
    },
    promocode: {
      type: String as PropType<string>,
      default: undefined,
    },
    promocodeColor: {
      type: String as PropType<string>,
      default: "black",
      validator(el) {
        return ["transparent-white", "transparent-black", "black"].some(
          (item) => item === el
        );
      },
    },
  },
});
